/* eslint-disable */
import axios from 'axios';
import qs from 'qs';
import { store } from '../redux/store';
import { onLogout } from '../utility/helper';

const envType = {
  DEV: "development",
  STAGING: "staging",
  PROD: "production",
  US_PROD: "us_production",
}

const develop = envType.PROD;

const cred = {
  url: {
    development: "http://localhost:8080/",
    staging: "https://centerable-quintessential-ma.ngrok-free.dev/",
    production: "https://backend.insightai.in/",
  },
};

export const WEB_ROUTE = {
  urlPrefix: develop == envType.DEV ? cred.url.development : develop == envType.STAGING ? cred.url.staging : cred.url.production
}

export const REQUESTS = {

  get: async (url, token) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    axios.defaults.headers.common["ngrok-skip-browser-warning"] = "skip-browser-warning"
    return axios.get(`${WEB_ROUTE.urlPrefix}${url}`)
      .then(res => {
        return res
      })
      .catch((error) => {
        if (error.response.status == 400) {
          // store.dispatch(CreditAction(error?.response?.data?.detail));
          return error
        } else if (error.response.status == 401){
          onLogout();
        }else {
          return error
        }
      })
  },
  post_without_token: async (url, body) => {
    return axios.post(`${WEB_ROUTE.urlPrefix}${url}`, qs.stringify({ ...body }))
      .then(res => {
        return res
      })
      .catch((error) => {
        if (error.response.status == 400) {
          // store.dispatch(CreditAction(error?.response?.data?.detail));
          return error
        } else if (error.response.status == 401){
          onLogout();
        } else {
          return error
        }
      })
  },
  post: async (url, token, body) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    return axios.post(`${WEB_ROUTE.urlPrefix}${url}`, qs.stringify({ ...body }))
      .then(res => {
        return res
      })
      .catch((error) => {

        if (error.response.status == 400) {
          // store.dispatch(CreditAction(error?.response?.data?.detail));
          return error
        } else if (error.response.status == 401){
          onLogout();
        } else {
          return error
        }
      })
  },
  postJson: async (url, token, body) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    axios.defaults.headers.common['Content-Type'] = 'application/json'
    return axios.post(`${WEB_ROUTE.urlPrefix}${url}`, body )
      .then(res => {
        return res
      })
      .catch((error) => {

        if (error.response.status == 400) {
          // store.dispatch(CreditAction(error?.response?.data?.detail));
          return error
        } else if (error.response.status == 401){
          onLogout();
        } else {
          return error
        }
      })
  },
  postFile: async (url, token, body) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    axios.defaults.headers.common['Content-Type'] = 'multipart/form-data';
    return axios.post(`${WEB_ROUTE.urlPrefix}${url}`, body)
      .then(res => {
        console.log(res)
        return res
      })
      .catch((error) => {

        if (error.response.status == 400) {
          // store.dispatch(CreditAction(error?.response?.data?.detail));
          return error
        } else if (error.response.status == 401){
          onLogout();
        } else {
          return error
        }
      })
  },

  put: async (url, token, body) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    return axios.put(`${WEB_ROUTE.urlPrefix}${url}`, qs.stringify({ ...body }))
      .then(res => {
        return res
      })
      .catch((error) => {

        if (error.response.status == 400) {
          // store.dispatch(CreditAction(error?.response?.data?.detail));
          return error
        } else if (error.response.status == 401){
          onLogout();
        }else {
          return error
        }
      })
  },
  patch: async (url, token, body) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    axios.defaults.headers.common["ngrok-skip-browser-warning"] = "skip-browser-warning"
    return axios.patch(`${WEB_ROUTE.urlPrefix}${url}`, qs.stringify({ ...body }))
      .then(res => {
        return res
      })
      .catch((error) => {

        if (error.response.status == 400) {
          // store.dispatch(CreditAction(error?.response?.data?.detail));
          return error
        } else if (error.response.status == 401){
          onLogout();
        }else {
          return error
        }
      })
  },
  delete: async (url, token) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    return axios.delete(`${WEB_ROUTE.urlPrefix}${url}`)
      .then(res => {

        return res
      })
      .catch((error) => {

        if (error.response.status == 400) {
          // store.dispatch(CreditAction(error?.response?.data?.detail));
          return error
        } else if (error.response.status == 401){
          onLogout();
        } else {
          return error
        }
      })
  },
  uploadFile: async (url, token, formData) => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    return axios.post(`${WEB_ROUTE.urlPrefix}${url}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(res => {

        return res;
      })
      .catch((error) => {

        if (error.response.status == 400) {
          // store.dispatch(CreditAction(error?.response?.data?.detail));
          return error
        } else if (error.response.status == 401){
          onLogout();
        } else {
          return error
        }
      })
  },
}